import React from 'react';
import moment from 'moment';
import { Button, Typography } from 'antd';
import PropTypes from 'prop-types';

const MercanetForm = ({
  seal,
  isLoading,
  selectedQuittances,
  contractStatus,
  textButton,
  allQuittances
}) => {
  const statusMessage = [
    'FORMAL_NOTICE',
    'WARRANTY_SUSPENSION',
    'TERMINATED_NON_PAYMENT'
  ];

  const checkAllQuittancesSelected = () => {
    const requiredToSelect = allQuittances.filter(
      (q) =>
        q.quittance_status === 'NOT_PAID' &&
        moment(q.period_date).isSameOrBefore(moment(), 'month')
    );
    if (requiredToSelect.length === 0) return false;
    return !requiredToSelect.every((q) =>
      selectedQuittances.some((s) => s.key === q._id)
    );
  };

  return (
    <form
      method="post"
      action={`${import.meta.env.VITE_MERCANET_URL}/paymentInit`}
    >
      <input type="hidden" name="InterfaceVersion" value="HP_2.20" />
      <input type="hidden" name="Data" value={seal?.sealData.join('|')} />
      <input type="hidden" name="Seal" value={seal?.seal} />
      <Button
        type="primary"
        htmlType="submit"
        loading={isLoading}
        disabled={
          statusMessage.includes(contractStatus)
            ? checkAllQuittancesSelected()
            : false
        }
      >
        {textButton || 'Payer'}
      </Button>
      {statusMessage.includes(contractStatus) && checkAllQuittancesSelected() && (
        <Typography
          style={{
            color: 'red',
            textAlign: 'center',
            marginTop: 14
          }}
        >
          Vous devez sélectionner toutes les quittances impayées avec le mois en
          cours.
        </Typography>
      )}
    </form>
  );
};

MercanetForm.propTypes = {
  seal: PropTypes.shape({
    sealData: PropTypes.arrayOf(PropTypes.string),
    seal: PropTypes.string
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  selectedQuittances: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contractStatus: PropTypes.string.isRequired,
  textButton: PropTypes.string,
  allQuittances: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

MercanetForm.defaultProps = {
  textButton: undefined
};

export default MercanetForm;
